import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import styles from "./OtpCodeInput.module.scss"

const OtpCodeInput = React.forwardRef(
  (
    {
      value,
      onChange,
      onBlur,
      name,
      error,
      errorMessage,
      disabled,
      autoFocus,
      className,
      theme,
    },
    ref,
  ) => {
    const handleChange = (e) => {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 6)
      onChange({
        target: {
          name: name || "otp",
          value: digits,
        },
      })
    }

    return (
      <div
        className={classNames(
          styles.wrap,
          theme === "light" && styles.wrapLight,
          className,
        )}
      >
        <input
          ref={ref}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          name={name || "otp"}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          maxLength={6}
          disabled={disabled}
          autoFocus={autoFocus}
          placeholder="000000"
          aria-label="Verification code"
          className={classNames(
            styles.input,
            theme === "light" && styles.inputLight,
            error && styles.inputError,
            error && theme === "light" && styles.inputErrorLight,
          )}
        />
        <div className={styles.hint}>6-digit code</div>
        {error && errorMessage ? (
          <div className={styles.error}>{errorMessage}</div>
        ) : null}
      </div>
    )
  },
)

OtpCodeInput.displayName = "OtpCodeInput"

OtpCodeInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.oneOf(["dark", "light"]),
}

OtpCodeInput.defaultProps = {
  value: "",
  onChange: () => {},
  onBlur: () => {},
  name: "otp",
  error: false,
  errorMessage: "",
  disabled: false,
  autoFocus: false,
  theme: "dark",
}

export default OtpCodeInput
